import React from 'react'
import PropTypes from 'prop-types'

import { QuestionnaireLinearProgressTable } from '../../components'
import helpers from 'helpers'

const ProgressByQuestionnaire = ({ questionnaires, ...rest }) => {
  const rows = helpers.myLgpd.mountProgressRows(questionnaires)

  return (
    <QuestionnaireLinearProgressTable
      title="Progresso por questionário"
      questionnaires={rows}
      percentage
      {...rest}
    />
  )
}

ProgressByQuestionnaire.propTypes = {
  questionnaires: PropTypes.array.isRequired,
}

export default ProgressByQuestionnaire
